import React from "react";
import DataDisplay from "../../../../../../components/dataDisplay/dataDisplay";
import { useSelector } from "react-redux";

export const ScoreCards = () => {
  const totalData = useSelector((state) => state.averageNumberOfVisitsPerClient.totalData);

  const scoreCards = Object.keys(totalData).map((key) => totalData[key]);

  const style = scoreCards.length <= 2 ? { width: "50%" } : {};

  return (
    <div data-testid="scorecards" className="scorecards" style={style}>
      {scoreCards.map(({ value, label, change, raw_data_link = "" }) => {
        if (value == undefined) return null;
        return (
          <DataDisplay
            key={label}
            value={value}
            label={label}
            type="default"
            toolTipContent={
              value >= 100000
                ? "Raw data is not available, if the number of visits more than 100,000"
                : null
            }
            toolTipId={label}
            url={raw_data_link}
            disableAnimation
            changeProps={{ changeValue: change / 100, showBorder: true }}
          />
        );
      })}
    </div>
  );
};
export default ScoreCards;
